import formats from '../../api/formats'
import AssistClasses from '../assist/AssistClasses.js'
import DocAbstract from './DocAbstract.js'
import store from '../../store'

class Strategy extends DocAbstract.Strategy {
  getTypeCode () {
    return 'PASSPORT_RF'
  }
  getTypeName () {
    return 'Паспорт РФ'
  }
  createModel () {
    var model = new Model()
    return model
  }
  createDefaultModel (individual) {
    return Object.assign(this.createModel(), individual
      ? {
        surname: individual.lastName ? individual.lastName.toUpperCase() : null,
        firstname: individual.firstName ? individual.firstName.toUpperCase() : null,
        patronymic: individual.middleName ? individual.middleName.toUpperCase() : null,
        sex: individual.sex,
        birthday: individual.birthday
      } : {})
  }
  updateSteps (scheme) {
    const formatSerNum = (v) => {
      v = v.replaceAll(' ', '')
      return v.slice(0, 4) + ' ' + v.slice(4)
    }
    const ruleSerNum = (v) => !v || /^\d{4}\s\d{6}$/.test(formatSerNum(v)) || 'Неверный формат - [4004 123456]'
    const ruleNameRu = (v) => !v || formats.isNameRu(v, 60) || 'Допустимы русские буквы'

    let steps = []

    new AssistClasses.Step(
      '',
      (step) => {},
      {
        scheme: [
          {
            fieldType: 'v-text-field',
            label: 'Фамилия',
            name: 'surname',
            rules: Array.of(ruleNameRu),
            grow: true,
            size: {sm6: true, xs12: true}
          },
          {
            fieldType: 'v-text-field',
            label: 'Имя',
            name: 'firstname',
            rules: Array.of(ruleNameRu),
            grow: true,
            size: {sm6: true, xs12: true}
          },
          {
            fieldType: 'v-text-field',
            label: 'Отчество',
            name: 'patronymic',
            rules: Array.of(ruleNameRu),
            grow: true,
            size: {sm8: true, xs8: true}
          },
          {
            fieldType: 'v-select',
            label: 'Пол',
            name: 'sex',
            itemText: 'text',
            itemValue: 'value',
            items: [
              {value: 'F', text: 'Жен.'},
              {value: 'M', text: 'Муж.'}
            ],
            grow: true,
            size: {sm4: true, xs4: true}
          },
          {
            fieldType: 'v-date-field',
            label: 'Дата рождения',
            name: 'birthday',
            grow: true,
            size: {sm6: true, xs12: true}
          },
          {
            fieldType: 'v-text-field',
            label: 'Место рождения',
            name: 'birthplace',
            grow: true,
            size: {sm6: true, xs12: true}
          },
          {
            fieldType: 'v-text-field',
            label: 'Серия номер',
            name: 'sernum',
            rules: Array.of(ruleSerNum),
            format: formatSerNum,
            grow: true,
            size: {sm4: true, xs12: true}
          },
          {
            fieldType: 'v-date-field',
            label: 'Дата выдачи',
            name: 'issued',
            grow: true,
            size: {sm4: true, xs12: true}
          },
          {
            fieldType: 'v-text-field',
            label: 'Код подразделения',
            name: 'issuerCode',
            grow: true,
            size: {sm4: true, xs12: true}
          },
          {
            fieldType: 'v-text-field',
            label: 'Выдан',
            name: 'issuer',
            grow: true,
            size: {sm12: true, xs12: true}
          },
          {
            fieldType: 'v-text-field',
            label: 'Адрес регистрации',
            name: 'address',
            grow: true,
            size: {sm12: true, xs12: true}
          }
        ]
      },
      {
      }).addToArray(steps)

    this.steps = steps
    return this
  }
  viewNumber (model) {
    let issued = formats.blank(model['issued'], formats.formatDate)
    let sernum = formats.blank(model['sernum'])
    return `${sernum} выдан: ${issued}`
  }
  viewTitleComp (model) {
    return formats.createComp(`
      <span>${this.getTypeName()}</span>
    `)
  }
  viewContentComp (model) {
    const _f = (v, f) => formats.blank(v, f)
    let value = this.viewContent(model)
    let caption = `
      <span>
        <span>Номер:&nbsp<b>${_f(model['sernum'])}</b></span><br/>
        <span>Дата выдачи:&nbsp<b>${_f(model['issued'], formats.formatDate)}</b></span>
      </span>
    `
    return {
      template: `<span><component :is="renderValueLink()"></component></span>`,
      methods: {
        renderValueLink () {
          return store.getters.renderValueLink(value, null, null, null, caption)
        }
      }
    }
  }
  viewContent (model) {
    const _f = (v, f) => formats.blank(v, f)
    return `
        Паспорт: ${_f(model['surname'])} ${_f(model['firstname'])} ${_f(model['patronymic'])}
        Номер: ${_f(model['sernum'])}
        Дата выдачи: ${_f(model['issued'], formats.formatDate)}
        Код подразделения: ${_f(model['issuerCode'])}
        Выдан: ${_f(model['issuer'])}
        Адрес: ${_f(model['address'])}
    `
  }
  viewContentComp1 (model) {
    let fields = [
      {value: formats.blank(model['sernum']), label: 'Номер:'},
      {value: formats.blank(model['issued'], formats.formatDate), label: 'Дата выдачи:'}
    ]
    return {
      template: `
        <div>
          <template v-for="item in fields">
            <span><component :is="renderValueLink(item)"></component></span>
          </template>
        </div>
        `,
      methods: {
        renderValueLink (item) {
          if (!item.value) {
            return ''
          }
          return store.getters.renderValueLink(item.value, item.label)
        }
      },
      data: () => ({
        fields: fields
      })
    }
  }
}

class Model {
  constructor () {
    this.modelType = '21.01'
  }
}

function createStrategy (cxt) {
  return new Strategy(cxt)
}

export default {
  createStrategy,
  Model
}



// WEBPACK FOOTER //
// ./src/components/people/DocPassportRF.js